import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { AuthenticationService } from '../../../../shared/services/authentication.service';

@Component({
  selector: 'app-pda-receiving-main',
  templateUrl: './pda-receiving-main.component.html',
  styleUrls: ['./pda-receiving-main.component.scss']
})
export class PdaReceivingMainComponent implements OnInit {

  constructor(private location: Location,
    public _authService: AuthenticationService
  ) { }

  ngOnInit() {
  }

  goBack(): void {
    this.location.back();
  }

}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/pda/receiving/main/pda-receiving-main.component.ts